const PlayButton = ({ onClick, className = '' }) => {
  return (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        onClick?.(e);
      }}
      className={`w-16 h-16 rounded-full border-2 border-cream bg-transparent flex items-center justify-center hover:scale-110 transition-transform duration-300 ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="w-6 h-6 text-cream ml-1"
      >
        <path d="M8 5v14l11-7z" />
      </svg>
    </a>
  );
};

export default PlayButton;
